"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _luxon = require("luxon");

var _sample = _interopRequireDefault(require("lodash/sample"));

var _Calendar = _interopRequireDefault(require("../Calendar"));

var _ResourceMenu = _interopRequireDefault(require("../ResourceMenu"));

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _dateTimeFormatter = require("../../constants/propTypes/dateTimeFormatter");

var _resource = require("../../constants/propTypes/resource");

var _timeZone = require("../../constants/propTypes/timeZone");

var _AvailableTimes = _interopRequireDefault(require("./AvailableTimes"));

var _anyResource = require("../../constants/anyResource");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styles = {
  calendar: {
    '@md-only': {
      paddingHorizontal: 'large'
    },
    '@lg': {
      paddingHorizontal: 'xlarge'
    }
  },
  availableTimeWrapper: {
    marginTop: 'medium'
  },
  tzDisplay: {
    'textAlign': 'center',
    'marginBottom': 'medium',
    '@xs-only': {
      marginVertical: 'xsmall'
    }
  },
  noAvailableTimes: {
    marginTop: 'medium',
    paddingHorizontal: 'medium',
    paddingVertical: 'large',
    textAlign: 'center',
    backgroundColor: 'section'
  }
};

var AvailableTimePicker = /*#__PURE__*/function (_Component) {
  _inherits(AvailableTimePicker, _Component);

  var _super = _createSuper(AvailableTimePicker);

  function AvailableTimePicker(props) {
    var _this;

    _classCallCheck(this, AvailableTimePicker);

    _this = _super.call(this, props);
    _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_this));
    _this.onAvailableTimeClick = _this.onAvailableTimeClick.bind(_assertThisInitialized(_this));
    _this.onExpandClick = _this.onExpandClick.bind(_assertThisInitialized(_this));
    _this.groupAvailableTimes = _this.groupAvailableTimes.bind(_assertThisInitialized(_this));
    _this.fetchAvailableDatesAndTimes = _this.fetchAvailableDatesAndTimes.bind(_assertThisInitialized(_this));
    _this.fetchDayAvailableTimes = _this.fetchDayAvailableTimes.bind(_assertThisInitialized(_this));
    _this.fetchMonthAvailableDates = _this.fetchMonthAvailableDates.bind(_assertThisInitialized(_this));
    _this.getResourceIds = _this.getResourceIds.bind(_assertThisInitialized(_this));
    _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_this));
    _this.onResourceClick = _this.onResourceClick.bind(_assertThisInitialized(_this));
    _this.resetState = _this.resetState.bind(_assertThisInitialized(_this));
    _this.state = {
      isMoreTimesHidden: {
        morning: true,
        afternoon: true,
        evening: true
      },
      availableTimes: [],
      availableTimesHash: {},
      availableDates: [],
      isoSelectedDate: null,
      selectedResource: null,
      isoSelectedAvailableTime: null,
      fetchingState: null
    };
    return _this;
  }

  _createClass(AvailableTimePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          resources = _this$props.service.resources,
          i18n = _this$props.i18n;
      this.setState({
        selectedResource: resources.length === 1 ? resources[0] : (0, _anyResource.anyResource)(i18n)
      }, function () {
        return _this2.fetchAvailableDatesAndTimes(_luxon.DateTime.local().toISO());
      });
    }
  }, {
    key: "resetState",
    value: function resetState() {
      var _this$props2 = this.props,
          setAvailableTime = _this$props2.setAvailableTime,
          setResource = _this$props2.setResource;
      this.setState({
        isoSelectedAvailableTime: null
      });
      setResource(null);
      setAvailableTime(null);
    }
  }, {
    key: "fetchAvailableDatesAndTimes",
    value: function fetchAvailableDatesAndTimes(isoDay) {
      var timeZone = this.props.timeZone;

      var luxonDayWithTz = _luxon.DateTime.fromISO(isoDay, {
        zone: timeZone
      });

      this.fetchDayAvailableTimes(luxonDayWithTz);
      this.fetchMonthAvailableDates(luxonDayWithTz);
    }
  }, {
    key: "getResourceIds",
    value: function getResourceIds() {
      var service = this.props.service;
      var selectedResource = this.state.selectedResource;

      if (selectedResource.id) {
        return [selectedResource.id];
      }

      var resourceIds = service.resources.map(function (_ref) {
        var id = _ref.id;
        return id;
      });
      return resourceIds;
    }
  }, {
    key: "fetchMonthAvailableDates",
    value: function fetchMonthAvailableDates(luxonDay) {
      var _this3 = this;

      var _this$props3 = this.props,
          fetchAvailableDates = _this$props3.fetchAvailableDates,
          timeZone = _this$props3.timeZone,
          service = _this$props3.service;

      var currentTime = _luxon.DateTime.local().setZone(timeZone);

      var startTime = currentTime.hasSame(luxonDay, 'month') ? currentTime.toISO() : luxonDay.startOf('month').toISO();
      var endTime = luxonDay.endOf('month').toISO();
      this.setState({
        fetchingState: 'fetching'
      });
      fetchAvailableDates({
        serviceId: service.id,
        resourceIds: this.getResourceIds(),
        startTime: startTime,
        endTime: endTime
      }).then(function (data) {
        _this3.setState({
          availableDates: data.available_dates,
          fetchingState: 'fetched'
        });
      })["catch"](function () {// Do nothing since user can still click dates
      });
    }
  }, {
    key: "fetchDayAvailableTimes",
    value: function fetchDayAvailableTimes(luxonDay) {
      var _this4 = this;

      var _this$props4 = this.props,
          fetchAvailableTimes = _this$props4.fetchAvailableTimes,
          service = _this$props4.service;
      var startTime = luxonDay.toISO();
      this.setState({
        fetchingState: 'fetching'
      });
      fetchAvailableTimes({
        serviceId: service.id,
        resourceIds: this.getResourceIds(),
        startTime: startTime,
        endTime: luxonDay.endOf('day').toISO()
      }).then(function (data) {
        var availableTimesHash = data.available_times;
        var availableTimes = Object.keys(availableTimesHash).sort(function (a, b) {
          if (a > b) return 1;
          if (a < b) return -1;
          return 0;
        });

        _this4.setState({
          fetchingState: 'fetched',
          availableTimesHash: availableTimesHash,
          availableTimes: availableTimes,
          isoSelectedDate: startTime
        });
      })["catch"](function () {
        _this4.setState({
          fetchingState: 'error'
        });
      });
    }
  }, {
    key: "onMonthChange",
    value: function onMonthChange(luxonDay) {
      var onMonthChange = this.props.onMonthChange;
      this.resetState();
      this.fetchMonthAvailableDates(luxonDay);
      onMonthChange();
    }
  }, {
    key: "onResourceClick",
    value: function onResourceClick(resource) {
      var _this5 = this;

      var onResourceClick = this.props.onResourceClick;
      this.resetState();
      this.setState({
        selectedResource: resource
      }, function () {
        var isoSelectedDate = _this5.state.isoSelectedDate;

        _this5.fetchAvailableDatesAndTimes(isoSelectedDate);
      });
      onResourceClick();
    }
  }, {
    key: "onDayClick",
    value: function onDayClick(luxonDay) {
      var _this$props5 = this.props,
          timeZone = _this$props5.timeZone,
          onDayClick = _this$props5.onDayClick;
      this.resetState(); // Current day based on merchant config

      var luxonCurrentMerchantTime = _luxon.DateTime.local().setZone(timeZone); // Checks if selected day is same as current day


      var isCurrentDaySelected = luxonDay.toISO() === luxonCurrentMerchantTime.startOf('day').toISO(); // If days are the same, send the current time so that it doesn't load times before current time

      this.fetchDayAvailableTimes(isCurrentDaySelected ? luxonCurrentMerchantTime : luxonDay);
      onDayClick();
    }
  }, {
    key: "onAvailableTimeClick",
    value: function onAvailableTimeClick(isoAvailableTime) {
      var _this$props6 = this.props,
          resources = _this$props6.service.resources,
          onAvailableTimeClick = _this$props6.onAvailableTimeClick,
          setAvailableTime = _this$props6.setAvailableTime,
          setResource = _this$props6.setResource;
      var _this$state = this.state,
          selectedResource = _this$state.selectedResource,
          availableTimesHash = _this$state.availableTimesHash;

      if (selectedResource.id === null) {
        var randomResourceId = (0, _sample["default"])(availableTimesHash[isoAvailableTime]).resource_id;
        var randomResource = resources.find(function (r) {
          return r.id === randomResourceId;
        });
        setResource(randomResource);
      } else {
        setResource(selectedResource);
      }

      setAvailableTime(isoAvailableTime);
      this.setState({
        isoSelectedAvailableTime: isoAvailableTime
      });
      onAvailableTimeClick();
    }
  }, {
    key: "onExpandClick",
    value: function onExpandClick(period) {
      this.setState({
        isMoreTimesHidden: _objectSpread({}, this.state.isMoreTimesHidden, _defineProperty({}, period, false))
      });
    }
  }, {
    key: "groupAvailableTimes",
    value: function groupAvailableTimes() {
      var timeZone = this.props.timeZone;
      var availableTimes = this.state.availableTimes;
      var groupedAvailableTimes = {
        morning: [],
        afternoon: [],
        evening: []
      };
      availableTimes.forEach(function (isoAvailableTime) {
        var luxonTime = _luxon.DateTime.fromISO(isoAvailableTime, {
          zone: timeZone
        });

        var hour = luxonTime.hour;

        if (hour < 12) {
          groupedAvailableTimes.morning.push(isoAvailableTime);
        } else if (hour >= 12 && hour < 18) {
          groupedAvailableTimes.afternoon.push(isoAvailableTime);
        } else {
          groupedAvailableTimes.evening.push(isoAvailableTime);
        }
      });
      return groupedAvailableTimes;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          resources = _this$props7.service.resources,
          fetchingComponent = _this$props7.fetchingComponent,
          timeZone = _this$props7.timeZone,
          maxFutureCalendarMonths = _this$props7.maxFutureCalendarMonths,
          section = _this$props7.section,
          i18n = _this$props7.i18n,
          dateTimeFormatter = _this$props7.dateTimeFormatter;
      var _this$state2 = this.state,
          fetchingState = _this$state2.fetchingState,
          availableDates = _this$state2.availableDates,
          availableTimes = _this$state2.availableTimes,
          isMoreTimesHidden = _this$state2.isMoreTimesHidden,
          selectedResource = _this$state2.selectedResource,
          isoSelectedAvailableTime = _this$state2.isoSelectedAvailableTime;
      var _UX2$Element = _guacWidgetCore.UX2.Element,
          Block = _UX2$Element.Block,
          Text = _UX2$Element.Text,
          Alert = _guacWidgetCore.UX2.Component.Alert;
      return /*#__PURE__*/_react["default"].createElement(Block, {
        font: "alt"
      }, fetchingState === 'fetching' && fetchingComponent, resources.length > 1 && selectedResource && /*#__PURE__*/_react["default"].createElement(_ResourceMenu["default"], {
        resources: resources,
        onResourceClick: this.onResourceClick,
        selectedResource: selectedResource,
        i18n: i18n
      }), /*#__PURE__*/_react["default"].createElement(Block, {
        style: styles.calendar
      }, /*#__PURE__*/_react["default"].createElement(_Calendar["default"], {
        highlightedDays: availableDates,
        onDayClick: this.onDayClick,
        onMonthChange: this.onMonthChange,
        timeZone: timeZone,
        maxFutureCalendarMonths: maxFutureCalendarMonths,
        dateTimeFormatter: dateTimeFormatter
      }), availableTimes.length ? /*#__PURE__*/_react["default"].createElement(Block, {
        style: styles.availableTimeWrapper
      }, /*#__PURE__*/_react["default"].createElement(Text, {
        style: styles.tzDisplay,
        "data-aid": _dataAids["default"].AVAILABLE_TIME_PICKER_TIME_ZONE
      }, dateTimeFormatter.getTimeZoneDisplayName()), /*#__PURE__*/_react["default"].createElement(_AvailableTimes["default"], {
        groupedAvailableTimes: this.groupAvailableTimes(),
        onAvailableTimeClick: this.onAvailableTimeClick,
        onExpandClick: this.onExpandClick,
        isMoreTimesHidden: isMoreTimesHidden,
        i18n: i18n,
        dateTimeFormatter: dateTimeFormatter,
        isoSelectedAvailableTime: isoSelectedAvailableTime
      })) : fetchingState !== 'error' && /*#__PURE__*/_react["default"].createElement(Block, {
        section: section === 'default' ? 'alt' : 'default',
        style: {
          marginBottom: 'medium'
        }
      }, /*#__PURE__*/_react["default"].createElement(Block, {
        style: styles.noAvailableTimes
      }, /*#__PURE__*/_react["default"].createElement(Text, {
        "data-aid": _dataAids["default"].AVAILABLE_TIME_PICKER_NO_AVAILABLE_TIMES_BODY,
        group: "featured"
      }, i18n.noAvailableTimesBody))), fetchingState === 'error' && /*#__PURE__*/_react["default"].createElement(Alert, {
        icon: "alert",
        style: {
          marginBottom: 'medium'
        },
        section: section
      }, i18n.errorBody)));
    }
  }]);

  return AvailableTimePicker;
}(_react.Component);

exports["default"] = AvailableTimePicker;
AvailableTimePicker.defaultProps = {
  onAvailableTimeClick: function onAvailableTimeClick() {},
  onResourceClick: function onResourceClick() {},
  onDayClick: function onDayClick() {},
  onMonthChange: function onMonthChange() {}
};
AvailableTimePicker.propTypes = {
  service: _propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    resources: _propTypes["default"].arrayOf(_resource.resourcePropType.isRequired).isRequired
  }).isRequired,
  timeZone: _timeZone.timeZonePropType.isRequired,
  maxFutureCalendarMonths: _propTypes["default"].number.isRequired,
  setResource: _propTypes["default"].func.isRequired,
  setAvailableTime: _propTypes["default"].func.isRequired,
  fetchAvailableTimes: _propTypes["default"].func.isRequired,
  fetchAvailableDates: _propTypes["default"].func.isRequired,
  dateTimeFormatter: _dateTimeFormatter.dateTimeFormatterPropType.isRequired,
  i18n: _propTypes["default"].shape({
    morningHeader: _propTypes["default"].string.isRequired,
    afternoonHeader: _propTypes["default"].string.isRequired,
    eveningHeader: _propTypes["default"].string.isRequired,
    expandPeriodCta: _propTypes["default"].string.isRequired,
    noAvailableTimesBody: _propTypes["default"].string.isRequired,
    errorBody: _propTypes["default"].string.isRequired,
    anyResourceHeader: _propTypes["default"].string.isRequired,
    anyResourceBody: _propTypes["default"].string.isRequired,
    ownerResourceHeader: _propTypes["default"].string.isRequired,
    expandResourceBodyCta: _propTypes["default"].string.isRequired,
    resourceSeparatorLine: _propTypes["default"].string.isRequired
  }).isRequired,
  onAvailableTimeClick: _propTypes["default"].func,
  onResourceClick: _propTypes["default"].func,
  onDayClick: _propTypes["default"].func,
  onMonthChange: _propTypes["default"].func,
  fetchingComponent: _propTypes["default"].node,
  section: _propTypes["default"].string
};